/* Goldfully AI 睡眠顧問 widget
 *
 * 架構：全部訊息 POST 去 /pages/gf-advisor（shop origin，冇 CORS 問題），
 * 該頁 body 由 yeye-web 後端每 5 分鐘同步，入面有完整對話 reply。
 * 真正嘅對話 state 喺 yeye-web /api/gf-advisor/chat；widget 用同一個
 * API，但經 /pages/gf-advisor 做「中繼頁」唔可行（Shopify 唔俾 POST body
 * 影響頁面內容），所以 widget 直接 call window.GF_ADVISOR_API（由
 * theme.liquid 注入）；若未設公開域名，GF_ADVISOR_API 留空 → widget
 * 顯示「顧問即將上線」訊息並提供 WhatsApp 連結。
 */
(function () {
  "use strict";

  var API = window.GF_ADVISOR_API || "";
  var SESSION_KEY = "gf_advisor_sid";

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function productHandle() {
    var m = location.pathname.match(/^\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function buildUI() {
    var fab = el("button", "", null);
    fab.id = "gf-advisor-fab";
    fab.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 18v-6a2 2 0 012-2h14a2 2 0 012 2v6"/><path d="M3 18h18v2H3z"/><path d="M6 10V7a3 3 0 013-3h6a3 3 0 013 3v3"/></svg><span>睡眠顧問</span><span class="gf-fab-dot"></span>';
    if (productHandle()) {
      fab.querySelector("span").textContent = "呢款啱唔啱我？";
      fab.classList.add("gf-fab-attn");
    }

    var panel = el("div");
    panel.id = "gf-advisor-panel";
    panel.innerHTML =
      '<div class="gf-adv-head"><div><span class="t">金寶麗 AI 睡眠顧問</span>' +
      '<span class="s">30 秒幫你揀啱床褥 · 10 年保養 · 100 晚試瞓</span></div>' +
      '<button class="gf-adv-close" aria-label="關閉">×</button></div>' +
      '<div id="gf-advisor-msgs"></div>' +
      '<div id="gf-advisor-typing">顧問諗緊…</div>' +
      '<div id="gf-advisor-input"><input type="text" placeholder="輸入你嘅問題…" maxlength="300">' +
      '<button type="button">送出</button></div>' +
      '<div id="gf-advisor-wa"><a href="https://wa.me/85266260268" target="_blank" rel="noopener">想搵真人顧問？WhatsApp 6626 0268</a></div>';

    document.body.appendChild(fab);
    document.body.appendChild(panel);

    fab.addEventListener("click", function () {
      panel.classList.toggle("open");
      fab.classList.remove("gf-fab-attn");
      if (panel.classList.contains("open") && !panel.dataset.booted) {
        panel.dataset.booted = "1";
        startConversation();
      }
    });
    panel.querySelector(".gf-adv-close").addEventListener("click", function () {
      panel.classList.remove("open");
    });

    var input = panel.querySelector("input");
    var btn = panel.querySelector("#gf-advisor-input button");
    btn.addEventListener("click", sendCurrent);
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") sendCurrent();
    });

    return { panel: panel, input: input };
  }

  var ui = null;
  var sid = null;
  var busy = false;

  function addMsg(role, text) {
    var box = document.getElementById("gf-advisor-msgs");
    var m = el("div", "gf-adv-msg " + role, text);
    box.appendChild(m);
    box.scrollTop = box.scrollHeight;
    return m;
  }

  function addChips(chips) {
    if (!chips || !chips.length) return;
    var box = document.getElementById("gf-advisor-msgs");
    var row = el("div", "gf-adv-chips");
    chips.forEach(function (c) {
      var b = el("button", "gf-adv-chip", c);
      b.addEventListener("click", function () {
        row.remove();
        send(c);
      });
      row.appendChild(b);
    });
    box.appendChild(row);
    box.scrollTop = box.scrollHeight;
  }

  function addCards(recs) {
    var box = document.getElementById("gf-advisor-msgs");
    recs.forEach(function (p) {
      var card = el("div", "gf-adv-card");
      var img = document.createElement("img");
      img.src = p.image || "";
      img.alt = p.title;
      img.loading = "lazy";
      var body = el("div", "c-body");
      body.appendChild(el("div", "c-name", p.title));
      if (p.quote || !p.price) {
        body.appendChild(el("div", "c-quote", "查詢價格"));
      } else {
        var price = el("div", "c-price", "$" + Number(p.price).toLocaleString("en-US"));
        if (p.compare_at && p.compare_at > p.price) {
          var s = document.createElement("s");
          s.textContent = "$" + Number(p.compare_at).toLocaleString("en-US");
          price.appendChild(s);
        }
        body.appendChild(price);
      }
      body.appendChild(el("div", "c-reason", p.reason || ""));
      var cta = el("a", "c-cta", (p.quote ? "查詢報價" : "睇產品詳情") + " →");
      cta.href = p.quote ? ("/pages/contact?product=" + encodeURIComponent(p.handle)) : p.url;
      body.appendChild(cta);
      card.appendChild(img);
      card.appendChild(body);
      box.appendChild(card);
    });
    box.scrollTop = box.scrollHeight;
  }

  function typing(on) {
    var t = document.getElementById("gf-advisor-typing");
    if (t) t.classList.toggle("on", !!on);
  }

  function startConversation() {
    var ctx = productHandle();
    callApi("", ctx ? { handle: ctx } : null);
  }

  function sendCurrent() {
    var v = ui.input.value.trim();
    if (!v || busy) return;
    ui.input.value = "";
    send(v);
  }

  function send(msg) {
    addMsg("user", msg);
    callApi(msg, null);
  }

  function callApi(msg, ctx) {
    busy = true;
    typing(true);
    if (!API) {
      typing(false); busy = false;
      addMsg("assistant", "AI 顧問系統啱啱推出，而家先經 WhatsApp 6626 0268 幫到你，即刻有真人跟進！");
      return;
    }
    fetch(API.replace(/\/$/, "") + "/api/gf-advisor/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        session_id: sid || sessionStorage.getItem(SESSION_KEY) || null,
        message: msg,
        product_context: ctx
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        typing(false); busy = false;
        if (d.session_id) {
          sid = d.session_id;
          try { sessionStorage.setItem(SESSION_KEY, sid); } catch (e) {}
        }
        if (d.reply) addMsg("assistant", d.reply);
        if (d.recommendations && d.recommendations.length) addCards(d.recommendations);
        addChips(d.questions);
      })
      .catch(function () {
        typing(false); busy = false;
        addMsg("assistant", "顧問暫時忙碌，請直接 WhatsApp 我哋 6626 0268，即刻有人幫你。");
      });
  }

  function injectQuoteCTA() {
    var h = productHandle();
    if (!h) return;
    // quote 產品：頁面有「查詢價格」字樣先加
    if (!document.body.innerText.includes("查詢價格")) return;
    var anchor = document.querySelector("main") || document.body;
    var btn = el("button", "gf-adv-quote-cta", "唔肯定？問下 AI 睡眠顧問先");
    btn.addEventListener("click", function () {
      document.getElementById("gf-advisor-fab").click();
    });
    anchor.appendChild(btn);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      ui = buildUI();
      injectQuoteCTA();
    });
  } else {
    ui = buildUI();
    injectQuoteCTA();
  }
})();
